<template>
  <div id="customerTotalFleet">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Customer Total Fleet</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'customerTotalFleet'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'customerTotalFleet'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                      mode="remote"
                      ref="customerTotalFleetTable"
                      title="Customer Total Fleet"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-select-all="onSelectAll"
                      @on-selected-rows-change="selectionChanged"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :select-options="{
                          enabled: false,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: 'custom-class',
                          selectionText: 'rows selected',
                          clearSelectionText: 'clear',
                      }"
                      :search-options="{
                      enabled: false,
                      }"

                >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  
  
  
  
  
  import {commonMixins} from '../../mixins/commonMixins';
  import {dataTableMixins} from '../../mixins/dataTableMixins';
  export default {
    name: "CustomerTotalFleet",
    metaInfo(){
        return {
          title : 'Customer Total Fleet | FleetPro Application'
        }
      },
    mixins: [commonMixins,dataTableMixins],
    data: () => ({
      cantAccessPage:"",
      loading: false,
      action: '',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
              label: 'Customer Company',
              field: 'company',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              sortable:false,
              filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "#company", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
                trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Customer Number',
              field: 'cust_no',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Customer Suffix',
              field: 'suffix',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "#company", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
                trigger: "enter" //only trigger on enter not on keyup
              },
              sortable:false
          },
          {
              label: 'Customer Name',
              field: 'cust_name',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Customer City',
              field: 'city',
              filterable: false,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Agreement Type',
              field: 'agreement_type',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Agreement Number',
              field: 'agreement_no',
              fpFieldType:"text",
              hidden:false,
              filterable: true,
              sortable: true,
          },
          {
              label: "Facility Responsible",
              field: "location",
              filterable: true,
              fpFieldType:"option",
              hidden:false,
          },
          {
              label: 'Unit',
              field: 'unit_no',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Unit Description',
              field: 'name',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
          {
              label: 'Assignment Date',
              field: 'date_out',
              hidden:false,
              fpFieldType:"date",
              filterable: true
          },
           {
              label: 'Contract Type',
              field: 'contract_type',
              fpFieldType:"text",
              hidden:false,
              filterable: true,
          },
          {
              label: 'Expiry Date',
              field: 'date_in',
              hidden:false,
              fpFieldType:"date",
              filterable: true
          },
          
          {
              label: 'Next MOT',
              field: 'next_mot',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Next PM',
              field: 'next_pm',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Next Tacho',
              field: 'next_tacho',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Next Safety',
              field: 'next_safety',
              fpFieldType:"text",
              hidden:false,
              filterable: false,
              sortable: false,
          },
          {
              label: 'Fixed Rate',
              field: 'fixed_rate',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
          {
              label: 'LIC Rate',
              field: 'lic_rate',
              fpFieldType:"integer",
              hidden:false,
              type:'number',
              filterable: false,
              sortable: false,
          },
            {
              label: 'Ownership',
              field: 'ownership',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
          },
      ],
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
      permissions: function(permission) {
          var self = this;
          permission.forEach(function (permissions) {
              if(permissions.name == 'customer_total_fleet_report') {
                  self.cantAccessPage = true;
              }
          });
          if(self.cantAccessPage == ''){
              self.cantAccessPage = false;
          }
      },
    },
    mounted: function(){
      var self = this;
      self.getPermissions();
    },
    methods:{
      loadList: function(){

        var self = this;
        self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + "/customer-total-fleetpro/list",
              type: "POST",
              crossDomain: true,
              headers: this.ajxHeaders,
              dataType: "json",
              data: {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: this.serverParams.columnFilters,
                sort: this.serverParams.sort,
                action: self.action,

              },
              success: function(data) {
                self.loading = false;
                //console.log(data.content[0]["id"]);
                  if (data.status == "success") {

                    if ( self.action == "export" ||  self.action == "export_queue") {

                        if ( data.code == "201" ) {
                            alert(data.message);
                        } else {

                            if ( self.action == "export" ) {

                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);

                            } else {

                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }

                        }

                        self.action = "list";
                        // self.loadList();
                        return;
                    } else {
                      if (data.content.row != undefined) {
                        self.rows = data.content.row;
                      }
                      self.totalRecords = data.content.totalRecords;
                    }
                  }
              },
              error: function(jqXHR, exception) {
                self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'contract-equipment-utilization')
              }
            });


      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/reports/CustomerTotalFleetReport.vue